import { isBrowser } from '.';

export const getWindowLocation = (): Location | undefined => (isBrowser ? window.location : undefined);
